import { IRestfulConfigMap } from "@core/data-access/restful";
import { envConfig } from "@env/env-config";

let UniqueKeyRestServiceConfig: IRestfulConfigMap = {
    uniqueKeyRestService: {
        appPath: envConfig.appPath("base"),
        isAuth: true,
        actions: {
            get: {
                method: "get",
                path: "api/common/key",
                testPath: "api/common/key",
                isAuth: true
            },
            getIds:{
                method: "get",
                path: "common/keys?size=:size",
                testPath: "common/keys?size=:size",
                isAuth: true,
                paramDefaults: {
                    size: "@size"
                }
            }
        }
    }
}


export { UniqueKeyRestServiceConfig };